// C.1 — Действия Лив Лайфа из v6 xlsx. 22 карты, реализованы 18,
// 4 legendary с особой логикой — стабы.

import { applyDamage } from '../../../combat.js';
import { healUnit } from '../heal.js';
import { applyPermanentBuff, applyTemporaryBuff } from '../../../buffs.js';
import { addPermanentKeyword } from '../../../keywords/permanent.js';
import { addTransientKeyword } from '../../../keywords/transient.js';
import { addInfectedStack, clearInfected } from '../../../keywords/infected.js';
import { applyImmuneFirstHit } from '../../../keywords/immune.js';
import { resurrectUnit } from '../resurrect.js';
import { evacuateUnitToHand } from '../evacuate.js';
import { KW } from '../../../keywords.js';
import { resolveTarget } from '../../../effects/targets.js';
import { registerImplementedAbility } from '../../warn-unimplemented.js';

// Этап 25: регистрация всех 22 Действий Лив Лайфа в реестре реализованных.
const LIVLIFE_ACTIONS_C1 = [
  'livlife_act_bio_cycle', 'livlife_act_bio_kataklism', 'livlife_act_bio_oblako',
  'livlife_act_bio_protocol', 'livlife_act_bio_razryv', 'livlife_act_bio_reserv',
  'livlife_act_bio_shield', 'livlife_act_bio_stimulyator',
  'livlife_act_bio_stimulyator_llj', 'livlife_act_boevoy_stimpak',
  'livlife_act_chrezvychayny_protokol', 'livlife_act_evakuatsionny_modul',
  'livlife_act_kiber_implant_llk', 'livlife_act_pandemia',
  'livlife_act_regeneratsia_protokol', 'livlife_act_standart_protokol',
  'livlife_act_triazh_protokol', 'livlife_act_velikoe_voskreshenie',
  'livlife_act_voskreshenie_lazaro', 'livlife_act_zabor_materiala',
  'livlife_act_zapasnik_llk', 'livlife_act_zashifrovannaya_probirka'
];
for (const id of LIVLIFE_ACTIONS_C1) registerImplementedAbility(id, 'order');

// Список Действий, требующих выбор цели игроком.
export const TARGETED_C1 = new Set([
  'livlife_act_bio_stimulyator',
  'livlife_act_standart_protokol',
  'livlife_act_zabor_materiala',
  'livlife_act_bio_shield',
  'livlife_act_bio_stimulyator_llj',
  'livlife_act_kiber_implant_llk',
  'livlife_act_zashifrovannaya_probirka'
]);

export function getActionTargetsC1(state, playerIdx, cardId) {
  const p = state.players?.[playerIdx];
  if (!p?.field) return [];

  const allies = [];
  for (const row of p.field) for (const u of row || []) if (u) allies.push(u);
  const enemy = state.players?.[1 - playerIdx];
  const enemies = [];
  if (enemy?.field) for (const row of enemy.field) for (const u of row || []) if (u) enemies.push(u);

  switch (cardId) {
    case 'livlife_act_bio_stimulyator':
    case 'livlife_act_standart_protokol':
    case 'livlife_act_zabor_materiala':
    case 'livlife_act_bio_shield':
    case 'livlife_act_bio_stimulyator_llj':
    case 'livlife_act_kiber_implant_llk':
      return allies;
    case 'livlife_act_zashifrovannaya_probirka':
      return enemies;
    default:
      return [];
  }
}

function findFreeSlot(player) {
  if (!player?.field) return null;
  for (let line = 0; line < 2; line++) {
    const row = player.field[line] || [];
    for (let s = 0; s < row.length; s++) if (row[s] === null) return { line, idx: s };
  }
  return null;
}

function findAllFreeSlots(player) {
  const result = [];
  if (!player?.field) return result;
  for (let line = 0; line < 2; line++) {
    const row = player.field[line] || [];
    for (let s = 0; s < row.length; s++) if (row[s] === null) result.push({ line, idx: s });
  }
  return result;
}

function randomFrom(state, arr) {
  if (!arr || arr.length === 0) return null;
  const i = state.rng?.int ? state.rng.int(arr.length) : Math.floor(Math.random() * arr.length);
  return arr[i];
}

export function resolveActionC1(state, playerIdx, cardId, target, opts = {}) {
  const p = state.players?.[playerIdx];
  if (!p) return { ok: false, reason: 'no_player' };

  switch (cardId) {
    // ------- Common -------
    case 'livlife_act_bio_stimulyator': {
      if (!target) return { ok: false, reason: 'no_target' };
      applyPermanentBuff(state, target, { atk: 0, armor: 0, hp: 3 }, cardId, 'Био-стимулятор');
      return { ok: true };
    }
    case 'livlife_act_standart_protokol': {
      if (!target) return { ok: false, reason: 'no_target' };
      healUnit(state, target, 3, { id: cardId, name_ru: 'Стандарт-протокол' });
      return { ok: true };
    }
    case 'livlife_act_zabor_materiala': {
      // Добор 1 карты + 1 урон выбранному союзнику.
      if (p.deck && p.deck.length > 0 && (p.hand?.length || 0) < 10) {
        const card = p.deck.shift();
        p.hand.push(card);
      }
      if (target) {
        applyDamage(target, 1, { state, source: { id: cardId, name_ru: 'Забор материала' } });
      }
      return { ok: true };
    }

    // ------- Rare -------
    case 'livlife_act_kiber_implant_llk': {
      if (!target) return { ok: false, reason: 'no_target' };
      applyPermanentBuff(state, target, { atk: 0, armor: 3, hp: 0 }, cardId, 'Кибер-имплант LL-K');
      return { ok: true };
    }
    case 'livlife_act_bio_shield': {
      if (!target) return { ok: false, reason: 'no_target' };
      applyPermanentBuff(state, target, { atk: 0, armor: 2, hp: 0 }, cardId, 'Био-щит');
      applyImmuneFirstHit(state, target, cardId);
      return { ok: true };
    }
    case 'livlife_act_bio_stimulyator_llj': {
      if (!target) return { ok: false, reason: 'no_target' };
      // QA-фикс: статбафф +2/0/0 был ПЕРМАНЕНТНЫМ (applyPermanentBuff), но текст
      // и dsl_order (buff_temp + until_end_of_next_turn) = ВРЕМЕННЫЙ «до конца
      // следующего хода». applyTemporaryBuff снимается в начале хода expiresAtTurn,
      // поэтому для «до конца следующего хода» → currentTurn+2 (живёт T и T+1).
      applyTemporaryBuff(state, target, { atk: 2, armor: 0, hp: 0 }, (state.currentTurn ?? 1) + 2, cardId, 'Био-стимулятор LL-J');
      // Пробитие — ВРЕМЕННОЕ: до конца следующего хода. transient keyword
      // кладётся в target.keywords (бой видит + бейдж на карте), чистится
      // cleanupTransientKeywords на границе хода (end-of-turn → expireAfterTurn=T+1).
      addTransientKeyword(target, KW.PIERCE, cardId, (state.currentTurn ?? 1) + 1);
      return { ok: true };
    }
    case 'livlife_act_zashifrovannaya_probirka': {
      if (!target) return { ok: false, reason: 'no_target' };
      // 3 стака сразу.
      addInfectedStack(state, target, cardId, 3);
      return { ok: true };
    }
    case 'livlife_act_bio_oblako': {
      // 1 стак Заражения 3 РАЗНЫМ случайным вражеским юнитам (без повторов).
      const enemy = state.players?.[1 - playerIdx];
      if (!enemy?.field) return { ok: true };
      const enemies = [];
      for (const row of enemy.field) for (const u of row || []) if (u) enemies.push(u);
      // Перемешиваем копию и берём первые N — гарантия РАЗНЫХ целей.
      const pool = enemies.slice();
      for (let i = pool.length - 1; i > 0; i--) {
        const j = state.rng?.int ? state.rng.int(i + 1) : Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      const N = Math.min(3, pool.length);
      for (let i = 0; i < N; i++) addInfectedStack(state, pool[i], cardId, 1);
      return { ok: true, hit: N };
    }
    case 'livlife_act_bio_cycle': {
      // Самого раненого вернуть в свою колоду с full hp/armor.
      const targets = resolveTarget(state, p.hero, 'ally_lowest_hp');
      if (targets.length === 0) return { ok: false, reason: 'no_wounded' };
      const u = targets[0];
      // Извлечь с поля, восстановить статы, в deck.
      const line = u.line, slot = u.slot;
      if (line == null) return { ok: false };
      p.field[line][slot] = null;
      if (u.current) {
        u.current.hp = u.base?.hp ?? u.current.hp;
        u.current.armor = (typeof u.maxArmorWithMods === 'number') ? u.maxArmorWithMods : (u.base?.armor || 0);
      }
      u.line = null;
      u.slot = null;
      p.deck.push(u);
      state.log?.add(`🔄 Био-цикл: ${u.name_ru} возвращён в колоду`);
      return { ok: true };
    }
    case 'livlife_act_bio_protocol': {
      // Все союзники +2 hp.
      const allies = resolveTarget(state, p.hero, 'ally_aoe_all');
      for (const t of allies) healUnit(state, t, 2, { id: cardId, name_ru: 'Био-протокол' });
      // Один союзный юнит получает Скрытность до конца следующего хода.
      const unitAllies = allies.filter(u => u.type === 'unit');
      const pick = randomFrom(state, unitAllies);
      // Скрытность — ВРЕМЕННАЯ: до конца следующего хода (transient keyword).
      if (pick) addTransientKeyword(pick, KW.STEALTH, cardId, (state.currentTurn ?? 1) + 1);
      return { ok: true };
    }
    case 'livlife_act_regeneratsia_protokol': {
      // Самого раненого союзника на full + Героя +4 hp.
      const targets = resolveTarget(state, p.hero, 'ally_lowest_hp');
      if (targets.length > 0) {
        const u = targets[0];
        const cur = u.current?.hp ?? 0;
        const max = u.base?.hp ?? cur;
        if (max > cur) healUnit(state, u, max - cur, { id: cardId, name_ru: 'Регенерация' });
      }
      if (p.hero) healUnit(state, p.hero, 4, { id: cardId, name_ru: 'Регенерация' });
      return { ok: true };
    }
    case 'livlife_act_triazh_protokol': {
      const line = opts?.chosenLine;
      if (line !== 0 && line !== 1) return { ok: false, reason: 'no_line' };
      const row = p.field?.[line] || [];
      for (const u of row) {
        if (!u) continue;
        const cur = u.current?.hp ?? 0;
        const max = u.base?.hp ?? cur;
        if (max > cur) healUnit(state, u, max - cur, { id: cardId, name_ru: 'Триаж-протокол' });
      }
      return { ok: true };
    }
    case 'livlife_act_voskreshenie_lazaro': {
      // Случайный юнит из своего сброса с 50% hp.
      const candidates = (p.discard || []).filter(c => c?.type === 'unit');
      if (candidates.length === 0) return { ok: false, reason: 'empty_discard' };
      const tpl = randomFrom(state, candidates);
      const slot = findFreeSlot(p);
      if (!slot) return { ok: false, reason: 'no_free_slot' };
      return resurrectUnit(state, tpl, playerIdx, slot, { hpMode: 'half_hp' })
        ? { ok: true } : { ok: false, reason: 'resurrect_failed' };
    }
    case 'livlife_act_zapasnik_llk': {
      // Добор 1 карты + случайный юнит из руки → в свой сброс.
      if (p.deck?.length > 0 && (p.hand?.length || 0) < 10) {
        p.hand.push(p.deck.shift());
      }
      const units = (p.hand || []).filter(c => c?.type === 'unit');
      const pick = randomFrom(state, units);
      if (pick) {
        const idx = p.hand.indexOf(pick);
        if (idx >= 0) {
          p.hand.splice(idx, 1);
          (p.discard = p.discard || []).push(pick);
          state.log?.add(`📦 Запасник: ${pick.name_ru} → в сброс`);
        }
      }
      return { ok: true };
    }

    // ------- Epic -------
    case 'livlife_act_bio_kataklism': {
      const enemy = state.players?.[1 - playerIdx];
      if (!enemy?.field) return { ok: true };
      let infected = 0;
      for (const row of enemy.field) {
        for (const u of row || []) {
          if (u) { addInfectedStack(state, u, cardId, 1); infected++; }
        }
      }
      return { ok: true, infected };
    }
    case 'livlife_act_bio_reserv': {
      // 2 случайных юнита из своего сброса с 50% hp.
      const candidates = (p.discard || []).filter(c => c?.type === 'unit');
      let count = 0;
      for (let i = 0; i < 2 && candidates.length > 0; i++) {
        const tpl = randomFrom(state, candidates);
        if (!tpl) break;
        const slot = findFreeSlot(p);
        if (!slot) break;
        if (resurrectUnit(state, tpl, playerIdx, slot, { hpMode: 'half_hp' })) {
          count++;
          // Удаляем из candidates чтобы не воскресить дважды.
          const idx = candidates.indexOf(tpl);
          if (idx >= 0) candidates.splice(idx, 1);
        }
      }
      return { ok: true, resurrected: count };
    }
    case 'livlife_act_boevoy_stimpak': {
      // +2/0/0 на 1 ход + -1 hp каждому союзнику.
      const allies = resolveTarget(state, p.hero, 'ally_aoe_all').filter(u => u.type === 'unit');
      const expiresAtTurn = (state.currentTurn ?? 1) + 2;
      for (const u of allies) {
        applyTemporaryBuff(state, u, { atk: 2, armor: 0, hp: 0 }, expiresAtTurn, cardId, 'Боевой стимпак');
        applyDamage(u, 1, { state, source: { id: cardId, name_ru: 'Боевой стимпак' } });
      }
      return { ok: true };
    }
    case 'livlife_act_evakuatsionny_modul': {
      // Все союзники → в руку. Лишние сгорают.
      const allies = [];
      for (const row of p.field || []) for (const u of row || []) if (u) allies.push(u);
      let returned = 0;
      for (const u of allies) {
        const r = evacuateUnitToHand(state, playerIdx, u, 'Эвакуационный модуль');
        if (r?.ok) returned++;
      }
      return { ok: true, returned };
    }

    // ------- Legendary -------
    case 'livlife_act_pandemia': {
      const enemy = state.players?.[1 - playerIdx];
      if (!enemy?.field) return { ok: true };
      let killed = 0;
      const toKill = [];
      for (const row of enemy.field) {
        for (const u of row || []) {
          if (u && (u.infectedStacks || 0) > 0) toKill.push(u);
        }
      }
      for (const u of toKill) {
        applyDamage(u, 999, { state, source: { id: cardId, name_ru: 'Пандемия' } });
        killed++;
      }
      return { ok: true, killed };
    }
    case 'livlife_act_velikoe_voskreshenie': {
      // Все юниты из своего сброса воскресают с 50% hp пока есть место.
      const candidates = (p.discard || []).filter(c => c?.type === 'unit');
      let count = 0;
      for (const tpl of [...candidates]) {
        const slot = findFreeSlot(p);
        if (!slot) break;
        if (resurrectUnit(state, tpl, playerIdx, slot, { hpMode: 'half_hp' })) count++;
      }
      return { ok: true, resurrected: count };
    }
    case 'livlife_act_chrezvychayny_protokol': {
      // Все союзники heal_to_full + 3 случайных юнит-карты из колоды на свободные ячейки.
      const allies = resolveTarget(state, p.hero, 'ally_aoe_all');
      for (const t of allies) {
        const cur = t.current?.hp ?? 0;
        const max = t.base?.hp ?? cur;
        if (max > cur) healUnit(state, t, max - cur, { id: cardId, name_ru: 'Чрезвычайный протокол' });
        if (t.current) t.current.armor = (typeof t.maxArmorWithMods === 'number') ? t.maxArmorWithMods : (t.base?.armor || 0);
      }
      // 3 случайных юнита из колоды.
      const unitsInDeck = (p.deck || []).filter(c => c?.type === 'unit');
      let summoned = 0;
      for (let i = 0; i < 3 && unitsInDeck.length > 0; i++) {
        const slot = findFreeSlot(p);
        if (!slot) break;
        const pick = randomFrom(state, unitsInDeck);
        if (!pick) break;
        // Извлечь из колоды и поставить.
        const deckIdx = p.deck.indexOf(pick);
        if (deckIdx >= 0) {
          p.deck.splice(deckIdx, 1);
          unitsInDeck.splice(unitsInDeck.indexOf(pick), 1);
          // Простой призыв на поле через placeCard.
          try {
            p.placeCard(pick, slot.line, slot.idx);
            pick.placedTurn = state.currentTurn;
            pick.revealed = true;
            summoned++;
          } catch {}
        }
      }
      return { ok: true, summoned };
    }
    case 'livlife_act_bio_razryv': {
      // Heal 3 всем союзникам + каждый союзник наносит 1 урон случайному вражескому юниту.
      const allies = resolveTarget(state, p.hero, 'ally_aoe_all');
      for (const t of allies) healUnit(state, t, 3, { id: cardId, name_ru: 'Био-разрыв' });
      const enemy = state.players?.[1 - playerIdx];
      if (enemy?.field) {
        const enemies = [];
        for (const row of enemy.field) for (const u of row || []) if (u) enemies.push(u);
        for (const a of allies.filter(u => u.type === 'unit')) {
          const t = randomFrom(state, enemies);
          if (t) applyDamage(t, 1, { state, source: a });
        }
      }
      return { ok: true };
    }

    default:
      return null; // не наш cardId — дальше fallback в старом dispatcher.
  }
}
